import React from 'react';
import { Form } from 'src/components/RcForm';

const ChangesMonitor = (props) => {
  const {
    setHasModified,
    pcForm,
    tabletForm,
    mobileForm,
    seoForm,
    loaded,
    orderForm,
    pageSettingForm,
  } = props;
  const pD = Form.useWatch([], pcForm);
  const tD = Form.useWatch([], tabletForm);
  const mD = Form.useWatch([], mobileForm);
  const sD = Form.useWatch([], seoForm);
  const oD = Form.useWatch([], orderForm);
  const paD = Form.useWatch([], pageSettingForm);
  React.useEffect(() => {
    if (setHasModified && loaded) {
      setHasModified(true);
    }
  }, [pD, tD, mD, sD, oD, paD]);
  return <React.Fragment />;
};
export default ChangesMonitor;
